export enum BundlesTypes {
  SAVE_BUNDLES = 'SAVE_BUNDLES'
}
